const createUserFirebase = (json) => {
  if (!json || !json.providerData) return null;
  // Only Facebook provider is supported now.
  const facebookProfile = json.providerData[0];
  const user = {
    displayName: facebookProfile.displayName || facebookProfile.email,
    email: facebookProfile.email || json.email || '',
    id: json.uid,
    facebookId: facebookProfile.uid,
    photoURL: facebookProfile.photoURL || '',
  };
  return user;
};

export default createUserFirebase;



// WEBPACK FOOTER //
// ./src/common/users/createUserFirebase.js